import { render, staticRenderFns } from "./classmanagetable.vue?vue&type=template&id=3b7d9de3&scoped=true&"
import script from "./classmanagetable.vue?vue&type=script&lang=js&"
export * from "./classmanagetable.vue?vue&type=script&lang=js&"
import style0 from "./classmanagetable.vue?vue&type=style&index=0&id=3b7d9de3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7d9de3",
  null
  
)

export default component.exports